// src/components/Experience.js
import React from 'react';
import './Experience.css';
import { arrowIcon, idbsLogo, uonLogo, uonsuLogo, uonsportLogo } from '../assets';
import { BioSection } from '../components';

const Experience = () => {
  const workExperienceItems = [
    {
      imgSrc: idbsLogo,
      title: 'Software Engineering Intern',
      institution: 'IDBS',
      date: "Aug '24 — Jul '25",
      hoverText: 'Placement year in industry at IDBS',
    },
    {
      imgSrc: uonsuLogo,
      title: 'Student Trustee',
      institution: 'UoN Students Union',
      date: "Dec '23 — Present",
      hoverText: 'Contributed to strategic discussions, policies, decisions, and financial oversight.',
    },
    {
      imgSrc: uonsportLogo,
      title: 'UoNMoves App Ambassador',
      institution: 'University of Nottingham Sports',
      date: "Aug '23 — Present",
      hoverText: 'Promoted the UoNMoves app, improved user experience and data analytics.',
    },
    {
      imgSrc: uonLogo,
      title: 'Senior Rep Computer Science',
      institution: 'University of Nottingham',
      date: "Sep '23 — Sep '24",
      hoverText: 'Worked with faculty to address issues, advocate for improvements, and coordinate student engagement',
    },
    {
      imgSrc: uonLogo,
      title: 'Digital Content Intern',
      institution: 'University of Nottingham Online',
      date: "Sep '23 — May '24",
      hoverText: 'Contributed to digital marketing and SEO, designed graphics, filming and edting',
    },
  ];

  return (
    <section id="experience" className="experience">
      <div className="titletext">
        <l1>WORK</l1>
        <l2ba>EXPERIENCE</l2ba>
      </div>

      <div className="divider"></div>

      <BioSection title={<img src={arrowIcon} className="arrow" alt="pointer"></img>} items={workExperienceItems} />

      <div className="divider-end"></div>
    </section>
  );
};

export default Experience;
